import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetAllFieldsByRoundManager = createAsyncThunk(
  "DropDowns/GetAllFields",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDownsManager/GetAllFieldsManager",
        param
      );
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "zaza");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetAllFieldsManagerForReportStage = createAsyncThunk(
  "DropDowns/GetAllFieldsManagerForReportStage",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDownsManager/GetAllFieldsManagerForReportStage",
        param
      );
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "zaza");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const DropDownFieldsManager = createSlice({
  name: "DropDownFieldsManager",
  initialState: {
    DropDownFieldsManager: [],
    loadingDropDownFieldsManager: false,
    errorDropDownFieldsManager: null,

    DropDownGetAllFieldsManagerForReportStage: [],
    loadingGetAllFieldsManagerForReportStage: false,
    errorGetAllFieldsManagerForReportStage: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllFieldsByRoundManager.pending, (state, action) => {
        state.loadingDropDownFieldsManager = true;
        state.DropDownFieldsManager = action.payload;
        state.errorDropDownFieldsManager = null;
      })
      .addCase(GetAllFieldsByRoundManager.fulfilled, (state, action) => {
        state.loadingDropDownFieldsManager = false;
        state.DropDownFieldsManager = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllFieldsByRoundManager.rejected, (state, action) => {
        state.loadingDropDownFieldsManager = false;
        state.errorDropDownFieldsManager = action.payload;
      })
      .addCase(GetAllFieldsManagerForReportStage.pending, (state, action) => {
        state.loadingGetAllFieldsManagerForReportStage = true;
        state.DropDownGetAllFieldsManagerForReportStage = action.payload;
        state.errorGetAllFieldsManagerForReportStage = null;
      })
      .addCase(GetAllFieldsManagerForReportStage.fulfilled, (state, action) => {
        state.loadingGetAllFieldsManagerForReportStage = false;
        state.DropDownGetAllFieldsManagerForReportStage = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllFieldsManagerForReportStage.rejected, (state, action) => {
        state.loadingGetAllFieldsManagerForReportStage = false;
        state.errorGetAllFieldsManagerForReportStage = action.payload;
      });
  },
});

export default DropDownFieldsManager.reducer;
